import PassportCheckBox, {
  PassportCheckBoxProps,
} from '@/components/Approval/LeftContainer/PeopleFilter/PassportCheckBox';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Layout,
  ResultCount,
} from '@/components/Approval/LeftContainer/PeopleFilter/SearchPassports/styles';
import React, { forwardRef } from 'react';
import { Passport } from '@/types/api';
import { useTranslation } from 'react-i18next';

type P = {
  data?: Passport[];
  currCursorIndex: number;
} & PassportCheckBoxProps;

const SearchPassports = forwardRef<HTMLDivElement, P>(
  ({ data, currCursorIndex, ...passportCheckboxProps }, ref) => {
    const { t } = useTranslation();
    return (
      <Layout ref={ref}>
        {data ? (
          <>
            <ResultCount>
              {t('검색결과')} <b>{data.length}</b>
              {t('건')}
            </ResultCount>
            {data.length > 0 ? (
              data.map((item, idx) => (
                <PassportCheckBox
                  key={`${passportCheckboxProps.filterName}-${item.passportId}`}
                  {...passportCheckboxProps}
                  cursorIndex={idx}
                  passportId={item.passportId}
                  profileImageUrl={item.detail.profileImageUrl}
                  positionName={item.detail.positionName}
                  name={item.detail.name}
                  divisionName={item.detail.divisionName}
                  departmentName={item.detail.departmentName}
                  isTarget={idx === currCursorIndex}
                />
              ))
            ) : (
              <div style={{ color: 'var(--dk-text-dim, #B7BBC2)', padding: '4px' }}>
                {t('일치하는 결과가 없어요.')}
                <br />
                {t('검색어를 다시 한번 확인해 주세요.')}
              </div>
            )}
          </>
        ) : (
          <div
            style={{
              color: 'var(--dk-text-dim, #B7BBC2)',
              margin: '0 auto',
              padding: '24px',
            }}
          >
            <CircularProgress color="inherit" size={'24px'} />
          </div>
        )}
      </Layout>
    );
  },
);

// Set the displayName for the SearchPassports component
SearchPassports.displayName = 'SearchPassports';

export default SearchPassports;
